
import React from 'react';
import SuperAdminLayout from '@/components/superadmin/SuperAdminLayout';
import { useSuperAdminSettings } from '@/hooks/useSuperAdminSettings';
import ReferralBankStats from '@/components/superadmin/referral/ReferralBankStats';
import ReferralIdList from '@/components/superadmin/referral/ReferralIdList';
import ReferralIdReportModal from '@/components/superadmin/ReferralIdReportModal';
import { useSuperAdminReferralBank } from '@/hooks/useSuperAdminReferralBank';

const SuperAdminReferralBank = () => {
  const { isLoading: isSettingsLoading, user, handleLogout } = useSuperAdminSettings();
  const {
    isLoading,
    referralIds,
    bankStats,
    isGenerating,
    searchQuery,
    setSearchQuery,
    handleGenerateMoreIds,
    handleCheckAndReplenish,
    refreshData
  } = useSuperAdminReferralBank();
  const [isReportModalOpen, setIsReportModalOpen] = React.useState(false);

  if (isLoading || isSettingsLoading) {
    return (
      <SuperAdminLayout
        isLoading={true}
        onLogout={handleLogout}
        userRole={user?.role}
        activeTab="referral-bank"
      >
        <div className="flex items-center justify-center p-12">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading referral ID bank...</p>
          </div>
        </div>
      </SuperAdminLayout>
    );
  }

  return (
    <SuperAdminLayout
      isLoading={false}
      onLogout={handleLogout}
      userRole={user?.role}
      activeTab="referral-bank"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Referral ID Bank Management</h1>
          <p className="text-gray-600">
            View and manage the pool of available referral IDs for all instances
          </p>
        </div>

        <ReferralBankStats 
          bankStats={bankStats}
          isGenerating={isGenerating}
          refreshData={refreshData}
          onOpenReportModal={() => setIsReportModalOpen(true)}
          handleCheckAndReplenish={handleCheckAndReplenish}
          handleGenerateMoreIds={handleGenerateMoreIds}
        />

        <ReferralIdList 
          referralIds={referralIds}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      </div>

      <ReferralIdReportModal 
        isOpen={isReportModalOpen}
        onClose={() => setIsReportModalOpen(false)}
      />
    </SuperAdminLayout>
  );
};

export default SuperAdminReferralBank;
